import { Reveal } from "@/components/Reveal";

const TERMS = [
  {
    title: "Advance Payment",
    text: "Initial orders are accepted against advance payment or confirmed payment before dispatch and delivery order release.",
  },
  {
    title: "Validity of Quotes",
    text: "Prices remain valid only for the period stated in the quotation, because spice rates move with market conditions.",
  },
  {
    title: "Stock Availability",
    text: "All orders are subject to physical stock remaining available at the time of final buyer approval and payment.",
  },
  {
    title: "Credit Policy",
    text: "Credit is not automatically available. Dispatch begins after payment confirmation and documentation.",
  },
];

export const CommercialTerms = () => {
  return (
    <section id="commercial-terms" className="py-16 bg-spice-sand border-y border-spice-line px-4 sm:px-6" data-testid="commercial-terms-section">
      <div className="max-w-7xl mx-auto space-y-8">
        <Reveal className="max-w-3xl space-y-2">
          <span className="text-xs font-bold uppercase tracking-widest text-spice-green">Transparent Trading</span>
          <h2 className="text-2xl sm:text-3xl font-bold text-spice-ink">Payment &amp; Commercial Discipline</h2>
          <p className="text-sm text-spice-muted">
            Clear commercial terms protect both parties and maintain consistency in lot execution.
          </p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {TERMS.map((term, i) => (
            <Reveal key={term.title} delay={i * 80}>
              <div className="bg-white p-5 rounded border border-spice-line space-y-2 h-full" data-testid={`commercial-term-${i + 1}`}>
                <h4 className="text-xs font-bold uppercase tracking-wider text-spice-green">{term.title}</h4>
                <p className="text-xs text-spice-muted leading-relaxed">{term.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
